// extracted by mini-css-extract-plugin
export default {"timeSlots":"TimeSlot_timeSlots__Z3Qn8","timeSlot":"TimeSlot_timeSlot__eG2V6","active":"TimeSlot_active__26TiV"};